import { SET_TAGS } from '../actions/types';

export default function tagReducer(state = [], action) {
	switch (action.type) {
		case SET_TAGS:
			if (Array.isArray(action.payload)) {
				// sort by name
				return action.payload.sort((a, b) => {
					const tagA = (a || '').toString();
					const tagB = (b || '').toString();
					return tagA.localeCompare(tagB);
				});
			}
			return action.payload || [];
		default:
			return state;
	}
}
